import clsxm from "@/lib/clsxm"

import Heading from "@/components/common/Heading/Heading"
import UnstyledLink from "@/components/common/Links/UnstyledLink"
import NextImage from "@/components/common/NextImage/NextImage"

type Props = {
  heading: string
  imageUrl: string
  imageAltText: string
  specialty: string
  className?: string
  text: string
}

export const ServiceItem = ({
  className,
  heading,
  imageUrl,
  imageAltText,
  specialty,
  text,
}: Props) => {
  return (
    <UnstyledLink
      href={`/booking?specialty=${specialty}&timeframe=next+7+days`}
      className={clsxm(
        `group relative flex h-full w-full flex-col rounded-lg bg-white p-3 pb-0  transition`,
        `first:col-start-1 first:col-end-1 first:row-start-1 first:row-end-1`,
        `sm:p-6 sm:pb-0`,
        className
      )}
    >
      <div className={`flex-grow-1 flex-shrink-1 overflow-hidden rounded-lg`}>
        <NextImage
          imgClassName={`object-cover`}
          src={imageUrl}
          alt={imageAltText}
          className={`block h-auto w-full`}
          height={`382`}
          width={`456`}
        />
      </div>
      <Heading
        className={`mt-4 mb-4 flex-shrink-0 text-lg transition group-hover:text-primary-500`}
        headingLevel={`h3`}
      >
        {heading}
      </Heading>
      <p className={`flex pb-5`}>{text}</p>
    </UnstyledLink>
  )
}
